// Talks to the Stew Discord helper (discord-helper/ in this repo) running on the listener's own
// computer. The helper turns what we send into a "Listening to …" Discord activity. When the helper
// isn't running nothing happens; it's opt-in per browser and checked quietly in the background.
const URL_WS = 'ws://127.0.0.1:47321';
const KEY = 'stew-discord';

let enabled = false;
try { enabled = window.localStorage.getItem(KEY) === '1'; } catch (e) { /* storage blocked */ }

let socket = null;
let retry = null;
let delay = 5000;
let last = null;          // the latest payload (null = nothing playing), resent when we (re)connect
let status = 'off';       // 'off' | 'searching' | 'connected'
const listeners = new Set();

const setStatus = (next) => {
  if (status === next) return;
  status = next;
  listeners.forEach(fn => fn(status));
};

const send = (payload) => {
  if (socket && socket.readyState === 1) socket.send(JSON.stringify(payload || { type: 'clear' }));
};

const connect = () => {
  if (!enabled || socket) return;
  setStatus('searching');
  let ws;
  try { ws = new WebSocket(URL_WS); } catch (e) { schedule(); return; }
  socket = ws;
  ws.onopen = () => { delay = 5000; setStatus('connected'); send(last); };
  ws.onclose = () => {
    if (socket === ws) socket = null;
    if (enabled) { setStatus('searching'); schedule(); }
  };
  ws.onerror = () => {}; // refused when the helper isn't running; onclose handles it
};

// Back off while the helper isn't there (5s, 10s … up to 1 minute).
const schedule = () => {
  clearTimeout(retry);
  retry = setTimeout(connect, delay);
  delay = Math.min(delay * 2, 60000);
};

export const isPresenceEnabled = () => enabled;

export const setPresenceEnabled = (on) => {
  enabled = !!on;
  try { window.localStorage.setItem(KEY, enabled ? '1' : '0'); } catch (e) { /* ignore */ }
  clearTimeout(retry);
  if (enabled) {
    delay = 5000;
    connect();
  } else {
    if (socket) { send(null); socket.close(); socket = null; }
    setStatus('off');
  }
};

export const subscribePresence = (fn) => {
  listeners.add(fn);
  fn(status);
  return () => listeners.delete(fn);
};

// `track` is { title, artist, album, coverUrl, songUrl, albumUrl, position, duration } while a song is
// playing, or null when nothing is.
export const sendPresence = (track) => {
  last = track ? { type: 'playing', ...track } : null;
  if (enabled) { connect(); send(last); }
};

// Start looking for the helper right away if the listener turned this on before.
if (enabled) connect();
